import React from 'react';
import PropTypes from 'prop-types';
import { ArticlePage, filterCategories } from '@/components/Articles';
import * as env from '@/env';
import { allArticles, prioritizeArticles } from '@/utilities/articles';

export default function CategoryArticles({ articles, category, featured, locale, numPages }) {
  return (
    <ArticlePage
      articles={articles}
      category={category}
      featured={featured}
      locale={locale}
      numPages={numPages}
    />
  );
}

CategoryArticles.propTypes = {
  articles: PropTypes.array.isRequired,
  category: PropTypes.string.isRequired,
  featured: PropTypes.array.isRequired,
  locale: PropTypes.string.isRequired,
  numPages: PropTypes.number.isRequired,
};

export async function getStaticProps({ params, locale }) {
  const numFeatured = env.NUM_FEATURED_ARTICLES;
  const pageSize = env.CONTENT_STACK_PAGINATE_AFTER;

  const allArticlesForLocale = prioritizeArticles(allArticles()[locale]);
  const articlesForCategory = allArticlesForLocale.filter((article) => article.article_category === params.category);

  const count = articlesForCategory.length;
  const numPages = Math.ceil((count - numFeatured) / pageSize);

  const featured = articlesForCategory.slice(0, numFeatured);

  const articles = articlesForCategory.slice(numFeatured, numFeatured + pageSize);

  return {
    props: {
      articles,
      category: params.category,
      featured,
      locale,
      numPages,
    },
  };
}

export async function getStaticPaths({ locales }) {
  let paths = [];

  for (const locale of locales) {
    paths = paths.concat(filterCategories.map(({category}) => ({
      params: {
        category,
      },
      locale: locale,
    })));

    paths = paths.concat({ params: { category: 'search' }, locale: locale });
  }

  return { paths, fallback: 'blocking' };
}
